import { getTimezoneOffset } from "./timezoneShift";

// The minute data and the EPG are kept on Turkey's clock.
const TURKEY_OFFSET = 3;

export function browserTimezone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "Europe/Istanbul";
  } catch {
    return "Europe/Istanbul";
  }
}

// How many minutes the timezone's clock is ahead of Turkey's on a day (YYYY-MM-DD).
export function shiftMinutesFor(timezone, ymd, sourceOffset = TURKEY_OFFSET) {
  if (!timezone || !ymd) return 0;
  const at = new Date(`${ymd}T12:00:00Z`);
  if (Number.isNaN(at.getTime())) return 0;
  return Math.round((getTimezoneOffset(timezone, at) - sourceOffset) * 60);
}

export function nowInTimezone(timezone) {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: timezone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  }).formatToParts(new Date());
  const get = (t) => parts.find((p) => p.type === t)?.value;
  return {
    key: `${get("year")}-${get("month")}-${get("day")}`,
    minute: Number(get("hour")) * 60 + Number(get("minute")),
  };
}

// EPG blocks (Turkey clock, grouped by Turkey day) placed on the selected
// timezone's day. A block outside that day is dropped, one crossing its edge is cut.
export function epgBlocksInTimezone(blocks, ymd, shiftMinutes) {
  const dayStart = Date.parse(`${ymd}T00:00:00Z`);
  const out = [];

  for (const b of blocks) {
    const blockDay = Date.parse(`${b.keyDate}T00:00:00Z`);
    if (Number.isNaN(blockDay) || Number.isNaN(dayStart)) continue;

    const dayOffset = Math.round((blockDay - dayStart) / 86400000) * 1440;
    const end = b.endMinute <= b.startMinute ? b.endMinute + 1440 : b.endMinute;

    const startMinute = Math.max(0, dayOffset + b.startMinute + shiftMinutes);
    const endMinute = Math.min(1439, dayOffset + end + shiftMinutes);
    if (endMinute <= startMinute) continue;

    out.push({ ...b, startMinute, endMinute });
  }

  return out.sort((a, b) => a.startMinute - b.startMinute);
}
